import { Component, createRef } from 'react'
import Input from '~/components/OrdersPage/Input'
import styles from '~/styles/ordersPage.lbOzInput.module.css'
import types from '~/types/ordersPage.ts'

export default class LbOzInput extends Component {
	static getInitialProps() {
		return {
			namespacesRequired: [ 'Orders', 'common' ],
		}
	}
	
	constructor(props) {
		super(props)
		this.state = {
			value: this.props.initial || 0,
		}
		this._weightLb = createRef()
		this._weightOz = createRef()
		if (this.props.valueSetterInit) {
			this.props.valueSetterInit(this._setValue.bind(this))
		}
	}
	
	render(): JSX.Element {
		const { lb, oz } = this._getLbOz()
		const { lb: defaultLb, oz: defaultOz } = this._getLbOz(this.props.defaultWeightGr || 0)
		return (
			<div className={styles.weightUs}>
				<Input
					value={lb}
					step="1"
					min="0"
					placeholder={defaultLb}
					onChange={this._onChangeWeightUs.bind(this)}
					after=" lb"
					widthRem={this.props.widthRem || "5"}
					focused="true"
					disabled={this.props.disabled}
					totalDisabled={this.props.totalDisabled}
					t={this.props.t}
					setRef={this._weightLb}
				/>
				<Input
					value={oz}
					step="1"
					minToLb="0"
					maxToLb="15"
					isRequiredFunction={(this.props.isRequired ? () => !this.state.value : null)}
					isRequiredSignInside={this.props.isRequiredSignInside}
					placeholder={defaultOz}
					onChange={this._onChangeWeightUs.bind(this)}
					after=" oz"
					widthRem={this.props.widthRem || "5"}
					marginLeftRem="0.25"
					focused="true"
					disabled={this.props.disabled}
					totalDisabled={this.props.totalDisabled}
					t={this.props.t}
					setRef={this._weightOz}
				/>
			</div>
		)
	}

	private _setValue(value): JSX.Element | null {
		this.setState({ value })
	}
	
	private _getLbOz() {
		let lbWeight = this.state.value
		if (!this.props.isNotMetrical) {
			const weightGr = this.state.value
			lbWeight = (weightGr * 2.20462262185) / 1000
		}
		let lb = Math.trunc(lbWeight)
		let oz = Math.round((lbWeight % 1) * 16)
		if (oz === 16) {
			lb += 1
			oz = 0
		}
		return { lb, oz }
	}
	
	private _onChangeWeightUs(): void {
		const lbWeight = +(this._weightLb?.current?.value) || 0
		const ozWeight = +(this._weightOz?.current?.value) || 0
		const lb = (+lbWeight + (ozWeight / 16))
		const grWeight = (lb * 1000) / 2.20462262185
		let value = lb
		if (!this.props.isNotMetrical) {
			value = grWeight
		}
		this.setState({ value })
		if (this.props.hasOwnProperty('initial')) {
			if (this._onPointsST) {
				clearTimeout(this._onPointsST)
			}
			this._onPointsST = setTimeout(() => {
				this.props.onChange(value)
			}, 600)
		}
	}
}